import React from 'react';
import { Fade } from 'reactstrap';

export default ({ children }) => <Fade className="view-fade">{children}</Fade>;
